import { useContext } from 'react';
import avatar from '../../assets/avatar.png';
import { Link } from 'react-router-dom';

import { AuthContext } from '../../contexts/auth';

import { FiHome, FiUser, FiBookmark,FiPlus,FiAward , FiLogOut } from 'react-icons/fi';

import 'bootstrap/dist/css/bootstrap.min.css';
import './header.css';

export default function Header(){
    const { user } = useContext(AuthContext);
    const { logout } = useContext(AuthContext);

    async function handleLogout() {
        await logout();
    }

    return (
        <div className="content">
        <div className="sidebar">
            <div className="container-fluid d-flex justify-content-center align-items-center">
                <img src={user.avatarUrl === null ? avatar : user.avatarUrl} alt="Foto do usuário" />
            </div>
            <br/>

            <Link to="/feed" className="column ml-2 d-flex align-items-center mb-4">
                <FiHome color='#BACDB0' size={30}/>
                Feed
            </Link>
            
            <Link to="/criarpost" className="column ml-2 d-flex align-items-center mt-3 mb-4">
                <FiPlus color='#BACDB0' size={30} />
                Criar Post
            </Link>
            <Link to="/meusposts" className="column ml-2 d-flex align-items-center mt-3 mb-4">
                <FiBookmark color='#BACDB0' size={30} />
                Meus Posts
            </Link>

            <Link to="/conquistas" className="column ml-2 d-flex align-items-center mb-4">
                <FiAward  color='#BACDB0' size={30}/>
                Conquistas
            </Link>

            <Link to="/perfil" className="column ml-2 d-flex align-items-center mt-3 mb-4">
                <FiUser color='#BACDB0' size={30} />
                Perfil
            </Link>

            <Link onClick={handleLogout} className="column ml-2 d-flex align-items-center mt-3 mb-4">
                <FiLogOut  color='#BACDB0' size={30} />
                Sair
            </Link>
        </div>
        </div>
    );
}
